import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomContactUsFormModel } from "@tCooneyBrothers/ApiModels";
import { addCustomContactUsFields as addCustomContactUsApi } from "@tCooneyBrothers/Services/CustomContactUsService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<CustomContactUsFormModel, CustomContactUsFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addCustomContactUsApi(props.parameter);
};

export const DispatchCustomContactUsFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomContactUsFields/fields",
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCustomContactUsFields];

const addCustomContactUsFormFields = createHandlerChainRunner(chain, "AddCustomContactUsFields");
export default addCustomContactUsFormFields;
